/*
    https://github.com/WebsiteBeaver/interactive-and-responsive-svg-map-of-us-states-capitals
*/

// Homeowners

$('.wm-content--homeowners .wm-interactive-map__svg').find('#AZ, #CA, #NV, #NM, #TX, #UT').hover(hoverState);

$('.wm-content--homeowners .wm-interactive-map__svg').find('#AZ, #CA, #NV, #NM, #TX, #UT').on('click', clickState);

// Seasonal

$('.wm-content--seasonal .wm-interactive-map__svg').find('#AZ, #CA, #NM, #TX, #UT, #NV').hover(hoverState);

$('.wm-content--seasonal .wm-interactive-map__svg').find('#AZ, #CA, #NM, #TX, #UT, #NV').on('click', clickState);

$('path, circle, polygon').mouseleave((e) => {
    $('#info-box').css('display', 'none');
});

$(document).mousemove((e) => {
    $('#info-box').css('top', e.pageY - $('#info-box').height() - 30);
    $('#info-box').css('left', e.pageX - $('#info-box').width()) / 2;
}).mouseover();

var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (ios) {
    $('a').on('click touchend', function () {
        var link = $(this).attr('href');
        window.open(link, '_blank');
        return false;
    });
}

function hoverState(e) {
    $('#info-box').css('display', 'block');
    $('#info-box').html($(this).data('info'));
}

function clickState(e) {
    e.preventDefault();
    let state = $(e.currentTarget).attr('id').toLowerCase();
    $('.wm-interactive-map__info-item').css('display', 'none');
    $(`.wm-interactive-map__info-item--${state}`).css('display', 'block');
}